import gql from 'graphql-tag';

export const TRACKED_PROPERTY = gql`
    query trackedProperties($offset: Int, $limit: Int) {
        user {
            userId
            trackedProperties(offset: $offset, limit: $limit) {
                total
                items {
                    relationship
                    property {
                        uprn
                        address {
                            fullAddress
                            postcode
                            country
                            outcode
                            latitude
                            longitude
                            uprn
                        }
                        attributes {
                            bathrooms
                            bedrooms
                            livingRooms
                            propertyType
                        }
                        saleEstimate {
                            lowerPrice
                            currentPrice
                            upperPrice
                            confidenceLevel
                        }
                        rentEstimate {
                            currentPrice
                            lowerPrice
                            upperPrice
                        }
                    }
                    permissions {
                        hasPermissions
                    }
                }
            }
        }
    }
`;
